import React, { Suspense } from 'react';

import classNames from 'classnames';

import { Skeleton } from './../../../../../Skeleton';
import { getActivePlayer } from './helpers';
import { PlayerEntry } from './helpers/PlayersEntries';
import { Player } from './Players';
import { useStyles } from './ReactPlayer.styles';
import type { ReactPlayerProps } from './types';

export const defaultProps: ReactPlayerProps = {
  src: '',
  width: '100%',
  height: '536px',
  volume: 1,
  playbackRate: 1,
};

type ReactPlayerType = React.ForwardRefExoticComponent<
  Omit<ReactPlayerProps, 'ref'> & React.RefAttributes<HTMLVideoElement>
>;

export const ReactPlayer: ReactPlayerType = React.forwardRef((props, ref) => {
  const combinedProps = { ...defaultProps, ...props };
  const { style, width, height, wrapper, src, slot, className } = combinedProps;
  const { classes } = useStyles({ width: width, height: height });

  const player = getActivePlayer(src);

  if (!player) return null;

  const config =
    combinedProps.config?.[player.key as keyof ReactPlayerProps['config']];

  return (
    <Suspense
      fallback={
        <Skeleton height={props.height} width={props.width} variant="rect" />
      }
    >
      <Player
        {...combinedProps}
        ref={ref}
        activePlayer={
          player.player ?? (player as unknown as PlayerEntry['player'])
        }
        slot={wrapper ? undefined : slot}
        className={wrapper ? classes.player : classNames([classes, className])}
        style={wrapper ? undefined : style}
        config={config}
      />
    </Suspense>
  );
});
